<template>
  <div>
    <Heading
      :class="jel_getClassObject(content, { [content.type]: true })"
      :contentType="content.type"
      v-html="jel_replaceTokens(content.titre)"
    ></Heading>
  </div>
</template>

<script>
import Heading from '@/components/base/Heading';

export default {
  name: 'Titre',
  components: { Heading },
  props: { content: { type: Object, required: true } },
};
</script>
